import { render, staticRenderFns } from "./RemitoIndex.vue?vue&type=template&id=7e072481"
import script from "./RemitoIndex.vue?vue&type=script&lang=js"
export * from "./RemitoIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports